export const fieldLabels = {
  currentCompliant:
    "Complete the following declaration in relation to your organisation's current compliance.",
  currentCompliantYes:
    "We are currently compliant with all Conditions of Recognition (except where alternative Ofqual/CCEA Regulation/Qualifications Wales regulatory frameworks are in place).",
  currentCompliantNo:
    "We are not currently compliant with all Conditions of Recognition (except where alternative Ofqual/CCEA Regulation/Qualifications Wales regulatory frameworks are in place).",
  currentCompliantDate:
    "Please select the date by which you will become compliant.",
  currentNonComplianceDescription:
    "Please describe the instance of non-compliance",
  currentNonComplianceMitigation:
    "Please describe how you plan to address this non-compliance.",
  nonComplianceNonOfqualConditions:
    "Please list any Qualification Wales or CCEA Regulation specific Conditions here.",
  futureCompliant:
    "Complete the following declaration in relation to your organisation's future compliance.",
  futureCompliantYes:
    "We believe that we are likely to be compliant in the next 12 months with all Conditions of Recognition (except where alternative Ofqual/CCEA Regulation/Qualifications Wales regulatory frameworks are in place).",
  futureCompliantNo:
    "We believe that we are likely to fail to fully comply with all Conditions of Recognition in the next 12 months (except where alternative Ofqual/CCEA Regulation/Qualifications Wales regulatory frameworks are in place).",
  futureNonComplianceDescription:
    "Please describe the instance of potential non-compliance.",
  futureNonComplianceMitigation:
    "Please describe how you plan to address this potential non-compliance.",
  futureNonComplianceHow:
    "Please explain how you know you are likely to fail to comply.",
  fullAccountsUpload:
    "Have you uploaded to the message chain your full accounts for 2023 that include a profit & loss statement, full balance sheet and notes? ",
  fullAccountsUploadYes:
    "Yes",
  fullAccountsUploadNo3months:
    "No but they will be uploaded within 3 months of our year end ",
  fullAccountsUploadNoCircumstances:
    "No, there are exceptional circumstances and we have agreed a timeline to upload with our regulators",
  fullAccountsUploadInformation:
    "Further information if applicable",
  financialPerformance2023Information:
    "Please provide a summary of your financial performance for 2023 and explain any material changes in your accounts compared to the previous year. ",
  totalRevenue:
    "Total Income / Revenue ",
  totalExpenditure: "Total expenditure",
  netProfit: "Net Surplus / Profit",
  cashInHand: "Cash at bank and in hand ",
  forecastAssumptionsInformation:
    "Please explain the assumptions used to generate the forecasts and any material changes versus the previous year.",
  cashReservesPolicy:
    "Do you have a cash reserves policy? ",
  CashReservesPolicyMet:
    "Do you currently meet your reserves policy? ",
  cashReservesPolicyMetInformation:
    "If not, what actions are you taking to rebuild your reserves? ",
  annualFixedCosts:
    "Annual fixed operating costs: ",
  cashReservesOverrideInformation:
    "Please provide details of anything that would override the cash reserves policy or cause you to deplete reserves (e.g., development costs, dividend payments, obligations, commitments to support other entities, etc.)? ",
  fundingSources:
    "Do you have access to other sources of funding in case of cashflow issues (e.g., unused agreed overdraft, credit line, liquid assets, commitment from shareholders/directors/related companies) ",
  fundingSourcesInformation:
    "Please provide details of your other sources of funding. ",
  customerRisksIdentifiedInformation: "As a result of the ongoing economic pressures, what customer risks have you identified?",
  //customerRisksManagedInformation: "What prevention and mitigation plans have you put in place to deal with these customer risks?",
  customerRisksManagedInformation: "What have you put in place to manage these customer risks in line with A6?",
  financialRisksInformation: "Aside from customer risk, what are the main financial risks and opportunities facing your organisation over the next 12 months? For each risk highlighted, please explain prevention and mitigation plans. These risks could be short-term, or long-term, and they might relate to the wider economy, political risk, the qualifications market or be specific to your organisation.",
  malpracticeGovernanceInformation: "Please describe the internal governance arrangements you have to assess the risk of malpractice and how you monitor the organisation's effectiveness in preventing and managing malpractice and maladministration on an ongoing basis.",
  malpracticeOperationalInformation: "Please describe the type of operational expertise, skills and experience you currently have in your organisation to support the prevention and management of malpractice or maladministration. How do you keep the expertise and skills you need up to date?",
  malpracticeResourceInformation: "How do you maintain sufficient resource to investigate incidents of malpractice and maladministration at all times?",
  decisionMakingRegulatorInformation: "your Regulator(s) of an incident about malpractice and or maladministration that could have an adverse effect?",
  decisionMakingAOAffectedInformation: "other awarding organisations of an occurrence of malpractice and or maladministration that may affect them?",
  decisionMakingAONotifyInformation: "how you decide which AOs to notify of an occurrence of malpractice?",
  aiRisksInformation: "What potential risks and opportunities have you identified with generative AI, in relation to the prevention and management of malpractice and maladministration in your qualifications?",
  aiSystems: "What systems and processes do you have in place for identifying, preventing and managing the risks of malpractice and maladministration associated with the use of generative AI?",
  aiCentres: "How do you support Centres to identify and manage the risk of generative AI related malpractice and maladministration, where Centres deliver assessments on your behalf?",
  qualificationExpertiseTypeInformation: "the types of expertise and resource required to support your qualification offer on an ongoing basis",
  qualificationExpertiseAvailabilityInformation: "the availability of the required expertise within your organisation and/or your ability to recruit the necessary expertise (where appropriate).",
  qualificationExpertiseExpansionInformation: "How, and when, is relevant expertise and resource determined and acquired when you decide to expand your qualification offer, especially into a subject area or a qualification type that you have not previously offered?",
  reviewProcessExpertiseInformation: "how you ensure that you acquire and retain appropriate expertise to maintain the validity of your qualifications",
  reviewProcessMonitoringInformation: "how you monitor and review the sufficiency and capability of the expertise.",

  furtherInformation: "Further Information",
  forecastRevenueIncome: "Revenue/income",
  forecastExpenditure: "Expenditure",
  forecastProfitSurplus: "Profit/surplus",
  forecastCashLiquidReserves: "Cash and other liquid reserves",
  forecastNumberOfEmployees: "Number of employees",
  forecastNumberOfContractors: "Number of contractors",
  itRiskManagementMitigation:
    "Considering your obligations under Conditions A5 and A6, please outline how your organisation mitigates and manages cyber security and data security risks.",
  itInsiderRiskMitigation: "Insider risks",
  epaOffered:
    "Do you offer apprenticeship end-point assessments regulated by Ofqual?",
  epaChallengeInCompliance:
    "What risks or challenges do you face in ensuring your compliance with the requirements of the Assessment Plan(s) you offer?",
  epaMitigationsDescription:
    "What mitigations do you have in place to manage these?",
  epaTrainingOffered:
    "Do you offer training to apprenticeship training providers or employers regarding the End Point Assessments you offer?",
  epaMaterialOffered:
    "Do you provide support materials to training providers or employers regarding the End Point Assessments you offer? In this context, support materials might include, but are not limited to, sample tests, practice questions, submission templates or other materials you provide to training providers or employers to help them prepare their apprentices for the EPA.",
  govBodyConfirmCompliance:
    "1. I confirm that the Statement of Compliance is accurate.",
  govBodyNoCompliance: "Non compliance statement",
  govBodyConfirmApproval:
    " 2. I confirm our Governing Body has formally approved the Statement of Compliance submission. I also confirm that, if requested, I am able to produce documents to verify that the Statement of Compliance was formally approved by the Governing Body.",
  govBodyConfirmNoApproval: "Non approval statement",
  govBodyConfirmChairRo:
    "3. Please confirm that both the Chair of the Governing Body and the Responsible Officer have signed off the Statement of Compliance submission. I also confirm that, if requested, I am able to produce documents to verify that the Statement of Compliance submission has been signed off by the Chair of the Governing Body and the Responsible Officer).",
  govBodyConfirmNoChairRo: "Non conformity statement",
  govBodyConfirmNameRo:
    "Please confirm the name of the Responsible Officer that signed off the Statement of Compliance:",
  govBodyConfirmNameChair:
    "Please confirm the name of the Chair of your Governing Body that signed off the Statement of Compliance:",
  govBodyConfirmSigningOnBehalfName: "Name",
  govBodyConfirmSigningOnBehalfTitle: "Job title",
  monthlyFixedCost: "Your monthly fixed operating costs",
  monthlyCoverage:
    "How many months cover does your current reserve balance equate to?",
  reserveThresholdLevel:
    "Is the current level of reserves above the minimum reserves threshold stated in your policy?",
  planToBuildReserve:
    "If reserves are below the minimum threshold, do you have a plan to build your reserves. If yes, please provide details.",
  planToBuildReserveDetails: "Additional details",
  inflationMitigationDetails: "Risk mitigation details",
  financialRisk: "Financial risk details",
  thirdPartyArrangement:
    "Do you have any existing or planned arrangements in place with third parties? Y/N",
  thirdPartyComplySummary:
    "Please provide a summary of how you evaluate a third party’s ability and willingness to act in a way that will enable you to comply with the conditions before entering an arrangement with them",
  thirdPartyInHouseSummary:
    "Please provide further information on how you manage all processes in house",
  thirdPartyArrangementNature:
    "Please explain the nature of your arrangement with third parties. For example are they informal agreements or formal contracts?",
  thirdPartyArrangementNatureSummary:
    "Please explain the nature of your arrangement with third parties. For example are they informal agreements or formal contracts?",
  thirdPartyExpectation:
    "How do you make clear to the third parties what you expect of them?",
  thirdPartyMonitorContingency: "Risk assess and review your arrangements with a third party, including any contingency plans should one cease to operate at short notice",
  thirdPartyMonitorContinuity: "Monitor whether a third party has appropriate risk management and business continuity plans",
  thirdPartyMonitorBreach: "Manage a failure in any agreement in place with a third party? For example, a breach of contract or failure against any Service Level Agreements",
  thirdPartyMonitorPerformance: "Manage poor performance of the third-party",
  sharedOperationFinance:
    "Do you have any shared ownership and/or operational, financial, resource, personnel, or governance arrangements with any centres? Y/N",
  conflictOfInterestIdentification:
    "If yes, how do you identify, review, monitor and manage conflict of interest in this area to ensure compliance with Condition A4: Conflicts of interest?",
  prohibitedTrainingFrequency:
    "How frequently is it delivered, and in what format?",
  prohibitedTrainingContent:
    "Please give an overview of the content covered in this training, including who delivers it.",
  prohibitedTrainingComplianceDescription:
    "In undertaking this training, how do you ensure compliance with our general Condition G4: Maintaining confidentiality of assessment materials?",
  prohibitedTrainingMaterialFrequency:
    "How frequently are these provided, and in what format?",
  prohibitedTrainingMaterialContent:
    "Please give an overview of the content covered in these materials.",
  prohibitedTrainingMaterialComplianceDescription:
    "In providing these materials, how do you ensure compliance with our general Condition G4: Maintaining confidentiality of assessment materials?",
  pleaseEnterYourResponse:"Please enter your response ",
  ifYesGiveShortSummary:"Please enter your response"
};

export const fieldLabelsOfqual = {
  agreeCurrentCompliant: "Agree with AO current compliance declaration",
  agreeFutureCompliant: "Agree with AO future compliance declaration",
  complianceDisagreement:
    "Reasons for disagreement with compliance declaration",
  complianceDisagreementDescription: "Reasons for disagreement description",
  complianceRagRating: "RAG rating - compliance",
  complianceFollowUp: "Follow up - compliance",
  complianceFollowUpStatus: "Follow up status - compliance",
  complianceClosureStatus: "Closure status - compliance",
  organisationalStabilityRagRating: "RAG rating - organisational stability",
  organisationFollowUpStatus: "Organisation follow up status",
  organisationFollowUp: "Organisation follow up",
  ragRating: "Rag rating - KLOE",
  followUp: "Follow up - KLOE",
  followUpStatus: "Follow up status - KLOE",
  lead: "Lead - KLOE",
  riskMarketsClosureStatus: "Risk and Markets closure status",
  followUpLead: "Follow up lead",
  closureStatus: "Closure status - KLOE",
  closingStatus: "Closing status",
  closingStatusRationale: "Closing status rationale",
  overallRagRating: "Overall RAG rating",
  meetingDate: "Event meeting date",
  eventType: "Event type",
  closeReason: "Reason",
  regComplianceClosureStatus: "Regulatory Compliance closure status",
  endpointAssessmentClosureStatus: "End Point Assessment closure status",
};
